import { AccessParams } from '../../interfaces/AccessParams';
import { apiService } from '../apiService';
import { EntitySignUpData } from '../../interfaces/EntitySignUpData';

type GetScanIqEntityDataOptions = {
  ignoreErrorCodes?: number[];
};

export const entitySignUpService = {
  async getEntityData(accessParams: AccessParams) {
    const { token, timestamp, hash } = accessParams;
    const params = { sub1: hash, sub2: timestamp, sub3: token };

    const resp = await apiService.get<EntitySignUpData>('api/sign-in/entity-data', {
      params,
    });

    return resp.data;
  },

  async getScanIqEntityData(
    accessParams: AccessParams,
    options: GetScanIqEntityDataOptions = {},
  ) {
    const { token, timestamp, hash } = accessParams;
    const params = { sub1: hash, sub2: timestamp, sub3: token };

    const resp = await apiService.get<EntitySignUpData>(
      'api/public/scan-iq/entity-data',
      {
        params,
        ...options,
      },
    );

    return resp.data;
  },
};
